export enum ThemeEnum {
  Light,
  Dark,
}
